import {useEffect} from "react";

interface IFacebookPixel{
    nameTracking: string;
}

export default function FacebookPixel(props: IFacebookPixel) {
    useEffect(() => {
        import("react-facebook-pixel")
            .then((x) => x.default)
            .then((ReactPixel) => {
                ReactPixel.init('918855728837349');
                ReactPixel.track(props.nameTracking);
            });
    }, []);

    return null;
}